import axiosInstance from "../libs/axiosInstance";


//  * Get public topics list (paginated)
export const getPublicTopics = async ({
  search_text=null, 
  course_id=null, 
  department_id=null, 
  faculty_id=null, 
  level=null,
  url=null,
  include_my=null,
}={}) => {
  try {
    const params = {
      ...(search_text && { search: search_text }),
      ...(course_id && { course_id }),
      ...(department_id && { department_id }),
      ...(faculty_id && { faculty_id }),
      ...(level && { level }),
      ...(include_my && { include_my: 1 })
    };
    
    const response = await axiosInstance.get(url || '/course_management/public/topics/', {
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching public topics:', error);
    throw error;
  }
};

// * Get public topics for select/dropdown (non-paginated)
export const getPublicTopicsSelect = async ({
  search_text=null,
  course_id=null,
  include_my=null,
}={}) => {
  try {
    const params = {
      ...(search_text && { search: search_text }),
      ...(course_id && { course_id }),
      ...(include_my && { include_my: 1 }),
    };
    
    const response = await axiosInstance.get('/course_management/public/topics/select/', {
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching public topics for select:', error);
    throw error;
  }
};


//  * Get public topic details
export const getPublicTopicDetail = async (topicId, query_param) => {
  try {
    const response = await axiosInstance.get(
      `/course_management/public/topics/${topicId}/`,
      {
        params: query_param
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching public topic detail:', error);
    throw error;
  }
};